import { render, staticRenderFns } from "./HeaderSlider.vue?vue&type=template&id=623b0cac&scoped=true&"
import script from "./HeaderSlider.vue?vue&type=script&lang=js&"
export * from "./HeaderSlider.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSlider.vue?vue&type=style&index=0&id=623b0cac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b0cac",
  null
  
)

export default component.exports